import React from 'react';
import api from '../api/api';

export default (props: {
  type?: string;
  idDoComponente: string;
  id: string;
  enderecoApi: string;
  descricaoBotao: string;
  nomeIdFormulario: string;
  retorno: (data: any) => void;
}) => {
  const { id, enderecoApi, descricaoBotao, retorno, idDoComponente, nomeIdFormulario, type } = props;

  const typeAppend = type ? `type-${type}` : '';

  const teveMudanca = () => {
    const input = document.getElementById(idDoComponente);
    const curFiles = input.files;

    const form = new FormData();
    form.append('File', curFiles[0]);
    form.append(nomeIdFormulario, id);

    api
      .post(enderecoApi, form, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
      .then(data => {
        input.value = '';
        retorno(data);
      });
  };

  return (
    <>
      <div className={`custom-type-file`}>
        <input type="file" onChange={teveMudanca} id={idDoComponente} className={`custom-input-type-file ${typeAppend}`} />
        <label className={`btn-upload ${typeAppend}`}>
          <span>{descricaoBotao}</span>
        </label>
      </div>
    </>
  );
};
